import { put, takeLatest } from 'redux-saga/effects';

import {
    SET_NAVIGATE_TO,
    TSetNavigationAction,
    TNavigationAction,
    NAVIGATE_TO,
    TSetBasePath,
    SET_BASE_PATH,
    BASE_PATH
} from './Navigation.action';

let navigateFunction: (path: string) => void;

function* handleSetNavigation(action: TSetNavigationAction) {
    navigateFunction = action.payload.navigate;
}

function* handleNavigation(action: TNavigationAction) {
    if (navigateFunction) {
        yield navigateFunction(action.payload.path);
    } else {
        console.error('Navigate function is not defined');
    }
}

function* handleSetBasePath(action: TSetBasePath) {
    yield put({
        type: BASE_PATH,
        basePath: action.payload.basePath
    });
}

export function* watchNavigation() {
    yield takeLatest(SET_NAVIGATE_TO, handleSetNavigation);
    yield takeLatest(NAVIGATE_TO, handleNavigation);
    yield takeLatest(SET_BASE_PATH, handleSetBasePath);
}
